var render, staticRenderFns
import script from "./SignatureBehaviors.vue?vue&type=script&lang=js&"
export * from "./SignatureBehaviors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c365fe')) {
      api.createRecord('73c365fe', component.options)
    } else {
      api.reload('73c365fe', component.options)
    }
    
  }
}
component.options.__file = "src/febos/global/pdf/mixins/SignatureBehaviors.vue"
export default component.exports